<template>
  <b-container fluid class="d-flex flex-column vh-100 p-0">
    <div class="p-3 bg-primary text-white"><h4>SafeNot</h4></div>
    <b-row align-v="center" align-h="center" class="d-flex flex-grow-1 bg m-0">
      <b-col cols="5" xl="3">
        <b-card header="Login" header-bg-variant="primary" header-text-variant="white" border-variant="dark">
          <b-card-text>
            <form method="post" @submit.prevent="login">
              <b-form-group label="Username">
                <b-form-input v-model="form.username" :state="validationState"></b-form-input>
                <b-form-invalid-feedback :state="validationState">
                  Login failed
                </b-form-invalid-feedback>
              </b-form-group>

              <b-form-group label="Password">
                <b-form-input type="password" v-model="form.password" :state="validationState"></b-form-input>
              </b-form-group>
              
              <b-form-checkbox v-model="form.rememberMe">Remember me</b-form-checkbox>
              <b-form-row>
                <b-col align-self="end">
                  <b-link href="#" @click.prevent="resetDialog = true"><small>Forgot your password?</small></b-link>
                </b-col>
                <b-col>
                  <b-btn class="float-right" variant="primary" type="submit">Login</b-btn>
                </b-col>
              </b-form-row>
            </form>
          </b-card-text>
        </b-card>
      </b-col>
    </b-row>

    <b-modal 
      v-model="resetDialog" title="Reset Password" @ok="sendReset"
      cancel-variant="outline-secondary"
      header-bg-variant="primary"
      header-text-variant="white"
      ok-title="Reset"
      centered
    >
      <b-form-group label="Email" >
        <b-input v-model="resetEmail"></b-input>
      </b-form-group>
    </b-modal>

  </b-container>
</template>
<script>
import axios from 'axios';

export default {
    data() {
      return {
        form: {
          username: '',
          password: '',
          rememberMe: false
        },
        validationState: null,
        resetDialog: false,
        resetEmail: ''
      }
    },
    methods: {
      login() {
        if (this.form.username === '' || this.form.password === '') return;
        
        this.$store.dispatch('login', this.form)
        .then(() => {
          this.$router.push('/');
        })
        .catch(() => {
          this.form.password = '';
          this.validationState = false;
        })
      },
      sendReset() {
        axios.post('/api/account/sendreset', { email: this.resetEmail })
        .then(() => {
          this.resetEmail = '';
          this.$bvToast.toast('Reset email sent.', {
            title: 'Email',
            variant: 'success'
          })  
        })
      }
    }
}
</script>
<style scoped>
  .bg {
    background-image: url("../assets/Back.jpg");
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;  
  }
</style>